module.exports = __webpack_public_path__ + "images/FUSA_icons/088-shopping-basket-1.856431ddc08282ef2fb3a8946b5aaced.svg";